import React from 'react';
import './InfoPage.css';

const Support: React.FC = () => {
  return (
    <div className="info-page">
      <div className="info-page-container">
        <h1>Support</h1>
        <p>
          Need help with your account, tools, or billing? Reach out and we will get back to you as soon as possible.
        </p>
        <p>
          Contact: <a href="mailto:support@deferredly.com">support@deferredly.com</a>
        </p>
        <ul>
          <li>Include your account email so we can locate your profile quickly.</li>
          <li>For tool issues, include the page name and a screenshot if possible.</li>
          <li>For login problems, mention whether you signed up with email or Google.</li>
        </ul>
      </div>
    </div>
  );
};

export default Support;
